import { AnalyticsDashboard } from '../components/analytics'

export default function AnalyticsPage() {
  return (
    <div className="funnels-theme space-y-6 animate-fade-in">
      <div className="flex flex-col gap-4 md:flex-row md:justify-between md:items-center">
        <div>
          <h1 className="text-2xl font-bold text-tf-text">Funnel Analytics</h1>
          <p className="text-tf-text-muted">Track funnel performance, conversions, and activity</p>
        </div>
      </div>
      <AnalyticsDashboard />
    </div>
  )
}
